export const setInputFieldIsDirtyEvent = (value: boolean) => {
  return new CustomEvent('isDirty', {
    detail: value,
  });
};
